export interface TemplateVariable {
  label: string
  value: string
}

export const templateVariablesList: TemplateVariable[] = [
  { label: 'Lien de création du compte', value: '{{account_creation_link}}' },
  { label: "Prénom de l'adoptant", value: '{{adopter_first_name}}' },
  { label: "Nom de l'adoptant", value: '{{adopter_last_name}}' },
  { label: "Email de l'adoptant", value: '{{adopter_email}}' },
  { label: "Téléphone de l'adoptant", value: '{{adopter_phone}}' },
  { label: "Adresse de l'adoptant", value: '{{adopter_address}}' },
  { label: "Code postal de l'adoptant", value: '{{adopter_postal_code}}' },
  { label: "Ville de l'adoptant", value: '{{adopter_city}}' },
  { label: "Date de l'acompte", value: '{{deposit_date}}' },
  { label: "Montant de l'acompte", value: '{{deposit_amount}}' },
  { label: "Mode de règlement de l'acompte", value: '{{deposit_payment_method}}' },
  { label: 'Montant restant dû post-acompte', value: '{{remaining_amount_after_deposit}}' },
  { label: 'Date du solde', value: '{{balance_date}}' },
  { label: 'Date du jour', value: '{{current_date}}' },
  { label: "Nom de l'animal", value: '{{animal_name}}' },
  { label: "Sexe de l'animal", value: '{{animal_gender}}' },
  { label: "Date de naissance de l'animal", value: '{{animal_birth_date}}' },
  { label: "Numéro d'identification de l'animal", value: '{{animal_identification_number}}' },
  { label: "Race de l'animal", value: '{{animal_breed}}' },
  { label: "Espèce de l'animal", value: '{{animal_species}}' },
  { label: "Montant de l'adoption", value: '{{adoption_fee}}' },
  { label: "Type d'adoption", value: '{{adoption_type}}' },
  { label: "Date d'adoption prévisionnelle", value: '{{adoption_date}}' },
  { label: "Nouveau nom de l'animal", value: '{{animal_new_name}}' },
  { label: "Nom du vétérinaire référent de l'animal", value: '{{veterinary_full_name}}' },
  { label: 'Prénom de la FA', value: '{{family_firstName}}' },
  { label: 'Nom de la FA', value: '{{family_lastName}}' },
  { label: 'Ville de la FA', value: '{{family_city}}' },
  { label: "Couleur de l'animal", value: '{{animal_color}}' },
  { label: 'Signes distinctifs', value: '{{identifying_marks}}' },
  { label: 'Statut vaccinal', value: '{{vaccine_status}}' },
  { label: 'Statut de stérilisation', value: '{{sterilization_status}}' },
  { label: 'Date de stérilisation', value: '{{sterilization_date}}' },
  { label: 'Montant de la caution de stérilisation', value: '{{sterilization_deposit_amount}}' },
  { label: 'Date J+7', value: '{{date_7_days}}' },
  { label: 'Date de préparation du contrat', value: '{{custom_contract_date}}' },
  { label: 'Date de préparation du certificat', value: '{{custom_certificate_date}}' },
  { label: 'Date dernier vaccin', value: '{{vaccine_last_date}}' },
  { label: 'Date dernier vermifuge', value: '{{deworming_last_date}}' },
  { label: 'Date dernier antiparasitaire', value: '{{flea_control_last_date}}' },
  { label: 'Date rappel vaccin', value: '{{vaccine_recall_date}}' },
  { label: 'Date rappel vermifuge', value: '{{deworming_recall_date}}' },
  { label: 'Date rappel antiparasitaire', value: '{{flea_control_recall_date}}' },
  { label: 'Commentaire spécifique', value: '{{asso_comment}}' },
]

export const translateVariablePlaceholder = (placeholder: string): string => {
  const variable = templateVariablesList.find((variable) => variable.value === placeholder)
  return variable ? variable.label : placeholder
}
